import { render, staticRenderFns } from "./ManageLookupLists.vue?vue&type=template&id=5846fea9&scoped=true&"
import script from "./ManageLookupLists.vue?vue&type=script&lang=js&"
export * from "./ManageLookupLists.vue?vue&type=script&lang=js&"
import style0 from "./ManageLookupLists.vue?vue&type=style&index=0&id=5846fea9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846fea9",
  null
  
)

export default component.exports